import { render } from "./HarwareKeyDisabler.vue?vue&type=template&id=154b81a4"
import script from "./HarwareKeyDisabler.vue?vue&type=script&lang=js"
export * from "./HarwareKeyDisabler.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__